export class AccountStatementTemplateApiModel {
    accountStatementTemplateID: number;
    organisationID: number;
    organisationName: string;
    subject: string;
    emailContent: string;
}